<template>
  <div class="min-h-screen bg-background">
    <PageHeader />

    <main>
      <!-- Top Banner -->
      <div class="bg-[#7c2622] py-16">
        <div class="mx-auto max-w-[1400px] px-8 lg:px-12">
          <h1 class="font-serif text-3xl lg:text-4xl text-white">
            Past Recipients
          </h1>
          <p class="text-white/70 mt-2">
            Businesses recognised for excellence since 2008.
          </p>
        </div>
      </div>

      <!-- Content -->
      <section class="py-20 lg:py-28 bg-background">
        <div class="mx-auto max-w-[1400px] px-8 lg:px-12">

          <div class="max-w-2xl mb-16 animate-fade-in">
            <p class="text-sm font-medium tracking-widest uppercase text-gray-500 mb-4">
              Past Recipients
            </p>

            <h2 class="font-serif text-3xl lg:text-4xl text-foreground mb-4">
              Recognised Businesses
            </h2>

            <p class="text-gray-600">
              A selection of souvenir businesses that have received
              the Excellence Award in recent years.
            </p>
          </div>

          <!-- Table -->
          <div class="border border-gray-200">

            <!-- Header Row -->
            <div class="grid grid-cols-12 gap-4 p-4 bg-gray-50 text-sm font-medium text-foreground border-b border-gray-200">
              <div class="col-span-5">Business</div>
              <div class="col-span-4">Category</div>
              <div class="col-span-3">Year</div>
            </div>

            <!-- Data Rows -->
            <div
              v-for="(recipient, index) in recipients"
              :key="recipient.name + recipient.year"
              class="grid grid-cols-12 gap-4 p-4 text-sm border-b border-gray-200 last:border-b-0 animate-fade-in hover:bg-gray-50 transition-colors"
              :style="{ animationDelay: index * 0.05 + 's' }"
            >
              <div class="col-span-5 font-medium text-foreground">
                {{ recipient.name }}
              </div>

              <div class="col-span-4 text-gray-600">
                {{ recipient.category }}
              </div>

              <div class="col-span-3 text-gray-600">
                {{ recipient.year }}
              </div>
            </div>

          </div>

          <!-- <p
            class="text-sm text-gray-500 mt-6 animate-fade-in"
            :style="{ animationDelay: '0.4s' }"
          >
            A complete list of all recipients since 2008 is available upon request.
          </p> -->

        </div>
      </section>
    </main>

    <PageFooter />
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import PageFooter from "@/components/PageFooter.vue"

export default {
  name: "Recipients",
  components: {
    PageHeader,
    PageFooter,
  },
  data() {
    return {
      recipients: [
        { name: "Choco Atelier", year: "2026", category: "Best Souvenir Retailer" },
        // { name: "Cultural Craft Collective", year: "2023", category: "Artisan Craftsmanship" },
        // { name: "Authentic Keepsakes Co.", year: "2023", category: "Cultural Authenticity" },
        // { name: "Green Memories Trading", year: "2022", category: "Sustainable Practices" },
        // { name: "Modern Heritage Designs", year: "2022", category: "Innovation in Souvenirs" },
        // { name: "Visitor's Choice Gallery", year: "2022", category: "Tourism Partnership" },
        // { name: "Traditional Arts Emporium", year: "2021", category: "Best Souvenir Retailer" },
        // { name: "Master Craftworks Studio", year: "2021", category: "Artisan Craftsmanship" },
      ],
    }
  },
}
</script>